export default "__VITE_ASSET__CuCyWub2__"